export const coursesFilterables = [
  'level1',
  'level2',
  'courses',
  'wiki_url',
];
